import angular from 'angular';
import {
  ecatDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-statement-document-dialog.controller';
import template from './edit-statement-document-dialog.html';
import ecatCRIDocumentNameMessagesTpl from './messages/ecat-cri-document.name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    findingId,
    document
  }) {
    return {
      controller,
      controllerAs: 'editCRIDocumentDialogVM',
      locals: {
        criStatementId,
        document,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editStatementDocumentDialog', [
  alerts,
  ecatDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editStatementDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('ecat-cri-document.name.messages.html', ecatCRIDocumentNameMessagesTpl);
  })
  .name;
